import { ProviderClientProperty } from '~/plugins/data-connector/types/provider.types'
import { NangoCommonType } from './strategy.nango.common'

type Options = NangoCommonType & {
  inputs?: ProviderClientProperty[]
}

export function NangoClient(options: Options) {
  return options
}
